export default __webpack_public_path__ + "static/media/logs_datatable_sample.27aec547.png";